import { useTranslation } from "react-i18next";
import { Globe, MessageCircle, Shield } from "lucide-react";
import dubaiVillaPanorama from "@/assets/dubai-villa-panorama.jpg";

const GulfConstructionSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Globe,
      title: t('gulf.feature1', 'AI-Translator for Multi-national Crews'),
    },
    {
      icon: MessageCircle,
      title: t('gulf.feature2', 'Deep WhatsApp Integration'),
    },
    {
      icon: Shield,
      title: t('gulf.feature3', 'GCC Compliance'),
    },
  ];

  return (
    <section className="bg-gradient-to-b from-slate-900 to-slate-800">
      <div className="py-20 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4" style={{ fontFamily: 'Impact, sans-serif' }}>
            {t('gulf.title', 'Driving the Future of Gulf Construction')}
          </h2>
          
          {/* Made in UAE tag */}
          <div className="flex justify-center mb-8">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2">
              <span className="text-xl">🇦🇪</span>
              <span className="text-white font-semibold text-sm uppercase tracking-wide">
                {t('gulf.madeIn', 'Made in UAE')}
              </span>
            </div>
          </div>
            
            <p className="text-lg md:text-xl text-slate-300 mb-10 leading-relaxed">
              {t('gulf.description', 'Combining world-class project management standards with full Arabic support and deep compliance with GCC regulations. Empowering the region\'s boldest projects with a digital ecosystem built for the scale and speed of the Vision 2030 era.')}
            </p>

            <div className="flex flex-wrap justify-center gap-3 md:gap-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2.5 text-white"
                >
                  <feature.icon className="w-5 h-5 text-primary" />
                  <span className="font-medium text-sm md:text-base">{feature.title}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      {/* Full-width panoramic image with gradient fade */}
      <div className="relative w-full">
        {/* Gradient overlay for smooth transition */}
        <div className="absolute inset-x-0 top-0 h-48 md:h-56 bg-gradient-to-b from-slate-800 via-slate-800/70 to-transparent z-10" />
        <img
          src={dubaiVillaPanorama}
          alt="Villa construction with Dubai skyline"
          width={2400}
          height={800}
          loading="lazy"
          decoding="async"
          className="w-full h-56 md:h-72 lg:h-80 object-cover"
        />
      </div>
    </section>
  );
};

export default GulfConstructionSection;
